// src/config/api.config.ts
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://labs.nessyfy.com';
export const API_PATH = '/api';